import { render, staticRenderFns } from "./OrderReviewProduct.vue?vue&type=template&id=737f8f8a&scoped=true&"
import script from "./OrderReviewProduct.vue?vue&type=script&lang=js&"
export * from "./OrderReviewProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737f8f8a",
  null
  
)

export default component.exports